var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCoinToWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 180 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-43.1269,-32.2395)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,50.6961,35.2605)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.27967e-17,-0.698924,0.698924,4.27967e-17,59.8555,51.3445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,5.333C32.736,5.333 33.364,5.594 33.885,6.115C34.406,6.636 34.667,7.264 34.667,8L34.667,49.563L48.771,35.437C49.284,34.924 49.916,34.667 50.667,34.667C51.431,34.667 52.067,34.92 52.573,35.427C53.08,35.933 53.333,36.569 53.333,37.333C53.333,38.084 53.076,38.716 52.563,39.229L33.896,57.896C33.382,58.41 32.75,58.667 32,58.667C31.25,58.667 30.618,58.41 30.104,57.896L11.437,39.229C10.924,38.716 10.667,38.084 10.667,37.333C10.667,36.569 10.92,35.933 11.427,35.427C11.933,34.92 12.569,34.667 13.333,34.667C14.084,34.667 14.716,34.924 15.229,35.437L29.333,49.563L29.333,8C29.333,7.264 29.594,6.636 30.115,6.115C30.636,5.594 31.264,5.333 32,5.333Z",
    style: {
      fill: "#FFE9A0",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,50.6961,35.2605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet--1-.svg",
    serifId: "wallet (1).svg",
    transform: "matrix(1,0,0,1,140.011,28.9789)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-32,-32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.224,10.259C49.286,10.587 49.317,10.92 49.317,11.255L49.317,12.108C53.158,12.75 55.999,16.106 56,20L56,25.501C58.301,26.095 60,28.181 60,30.667L60,40C60,42.424 58.347,44.558 56,45.165L56,50.667C56,55.055 52.389,58.667 48,58.667L12,58.667C7.611,58.667 4,55.055 4,50.667L4,20C4,15.617 7.601,12.009 11.984,12L11.984,11.911L42.989,6.013C43.318,5.951 43.651,5.919 43.986,5.919C46.537,5.919 48.749,7.751 49.225,10.257L49.224,10.259ZM48,16L12,16C9.894,16 8.13,17.663 8.007,19.765L8,20L8,50.667C8,52.773 9.663,54.536 11.765,54.66L12,54.667L48,54.667C50.106,54.667 51.87,53.004 51.993,50.901L52,50.667L52,45.333L40.667,45.333C35.181,45.333 30.667,40.819 30.667,35.333C30.667,29.847 35.181,25.333 40.667,25.333L52,25.333L52,20C52,17.894 50.337,16.13 48.235,16.007L48,16ZM54.667,29.333L40.667,29.333C37.375,29.333 34.667,32.042 34.667,35.333C34.667,38.518 37.203,41.177 40.384,41.327L40.667,41.333L54.667,41.333C55.339,41.333 55.912,40.824 55.991,40.156L56,40L56,30.667C56,29.994 55.491,29.421 54.823,29.343L54.667,29.333ZM40.667,33.333C41.764,33.333 42.667,34.236 42.667,35.333C42.667,36.431 41.764,37.333 40.667,37.333C39.569,37.333 38.667,36.431 38.667,35.333C38.667,34.236 39.569,33.333 40.667,33.333ZM43.891,9.924L43.736,9.945L32.927,11.999L45.316,11.999L45.316,11.192L45.295,11.005C45.169,10.345 44.561,9.878 43.891,9.925L43.891,9.924Z",
    style: {
      fill: "#FFE9A0",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,50.6961,35.2605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin.svg",
    transform: "matrix(1,0,0,1,24.4308,28.9789)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-32,-32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3,29.3L28,29.3C25.6,29.3 23.7,27.4 23.7,25.3C23.7,23.2 25.6,21.3 28,21.3L40,21.3C41.6,21.3 42.7,20.2 42.7,18.6C42.7,17 41.6,15.9 40,15.9L34.7,15.9L34.7,13.2C34.7,11.6 33.6,10.5 32,10.5C30.4,10.5 29.3,11.6 29.3,13.2L29.3,16L28.2,16C22.9,16 18.6,20.3 18.6,25.3C18.6,30.3 22.9,34.6 28.2,34.6L36.5,34.6C38.9,34.6 40.8,36.5 40.8,38.6C40.8,40.7 38.7,42.6 36.3,42.6L24,42.6C22.4,42.6 21.3,43.7 21.3,45.3C21.3,46.9 22.4,48 24,48L29.3,48L29.3,50.7C29.3,52.3 30.4,53.4 32,53.4C33.6,53.4 34.7,52.3 34.7,50.7L34.7,48L36.3,48C41.6,48 45.9,43.7 45.9,38.7C45.9,33.7 41.6,29.3 36.3,29.3Z",
    style: {
      fill: "#FFE9A0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,0C14.4,0 0,14.4 0,32C0,49.6 14.4,64 32,64C49.6,64 64,49.6 64,32C64,14.4 49.6,0 32,0ZM32,58.7C17.3,58.7 5.3,46.7 5.3,32C5.3,17.3 17.3,5.3 32,5.3C46.7,5.3 58.7,17.3 58.7,32C58.7,46.7 46.7,58.7 32,58.7Z",
    style: {
      fill: "#FFE9A0",
      fillRule: "nonzero"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCoinToWallet);
export default __webpack_public_path__ + "static/media/add_coin_to_wallet.5d22d51cbf98052f6b431f529928baa1.svg";
export { ForwardRef as ReactComponent };